import { Redirect } from 'react-router-dom';
export default Redirect;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_umi@2.6.8@umi/lib/redirect.js
// module id = null
// module chunks = 